import type { ReactNode } from "react";
import { Link } from "react-router";
import styles from "./AuthLayout.module.css";

interface AuthLayoutProps {
  readonly children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      <Link to="/" className={styles.wordmark}>
        TidyRota
      </Link>
      <div className={styles.card}>{children}</div>
    </div>
  );
}
